var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_33364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5947 43.1873C18.2537 42.4892 17.8877 41.7511 17.5328 41.0085C16.2841 38.4002 15.0399 35.7904 13.7932 33.1816C13.5088 32.5867 13.5344 32.4226 13.9861 31.957C16.5838 29.2745 19.1816 26.592 21.78 23.909C22.1111 23.567 22.1524 23.137 21.8905 22.8073C21.6208 22.4681 21.1762 22.4208 20.7656 22.69C17.5948 24.7641 14.4233 26.8387 11.2525 28.9128C10.9254 29.1268 10.6482 29.1314 10.3362 28.9014C7.4326 26.761 4.52946 24.6225 1.63437 22.4716C1.04635 22.0347 0.690463 21.4542 0.793651 20.6812C0.891488 19.9516 1.39367 19.4225 2.17938 19.2328C4.53786 18.6624 6.89711 18.0972 9.25637 17.5319C16.6329 15.7622 24.0096 13.9912 31.3867 12.2222C32.7702 11.8903 33.9988 12.6052 34.2813 13.902C34.4035 14.4637 34.2847 14.9853 34.0498 15.5019C31.7274 20.6086 29.4128 25.7191 27.0953 30.8275C25.2851 34.8167 23.4756 38.8054 21.6606 42.7917C21.1807 43.8458 20.0694 44.2209 19.1522 43.6426C18.9684 43.5265 18.8126 43.3668 18.596 43.1874L18.5947 43.1873Z",
    fill: "#070046"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_33364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(0.0444336 20.7173) rotate(-39.5417)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.db99add3acb5a0d00b137dea8f8fcf39.svg";
export { ForwardRef as ReactComponent };